import {Controller} from "stimulus"
import $ from 'jquery';
import {httpGet} from '../utils/http';

import 'select2/dist/css/select2.css'
import 'select2-bootstrap-theme/dist/select2-bootstrap.css'

// M10: httpGet centraliza el manejo de errores; ante error resuelve [] (catálogo vacío)
export let catalog = () => httpGet(
    `/${sessionStorage.getItem('locale')}/admin/catalogs/json`,
    {},
    { resolveOnError: [] }
).then(catalog => {
    if (catalog.length > 0) {
        return { success: true, data: catalog, code: 200 };
    }
    return { success: false, data: {}, code: 500 };
})

export let preferences = (text) =>new Promise((resolve, reject)=>{
    $.ajax({
        url: location.origin + `/${sessionStorage.getItem('locale')}/config/get_preference`,
        data: {
            text: text
        },
        type: 'GET',
        success: function (data) {
            resolve(data[0]);
        }
    })
})
export default class extends Controller {

    initialize(){
        let category_field = $('#catalog_category');
        let category_id_field = $('#catalog_categoryid');
        if(location.pathname.includes('edit')){
            let option = new Option(category_field.val(), category_id_field.val(), true, true);
            $('#catalog_select_category_aux').append(option).trigger('change');
        }else{
            category_field.val('');
            category_id_field.val('');
        }
    }

    connect() {
        let category_field = $('#catalog_category');
        let category_id_field = $('#catalog_categoryid');


        $('#catalog_select_category_aux').select2({
            theme: "bootstrap",
            ajax: {
                url: location.origin+`/${sessionStorage.getItem('locale')}/admin/products/get_categories_active`,
                data: {
                },
                type: "GET",
                processResults: function (data, params) {
                    let result = [];

                   data.map( elem => {
                       result.push({
                           id: elem.code+'|'+elem.name,
                           text: elem.name
                       })
                   })

                        return {
                            results: result
                        }


                }
            }
        }).on('change', function (e) {
            let value = e.target.value;
            value = value.split('|');
            category_field.val(value[value.length-1]);
            $('#select2-catalog_select_category_aux-container').text(value[value.length-1]);
            value.pop();
            category_id_field.val(value.join('|'));
        })


    }


}